import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Clock, Bell, Calendar } from 'lucide-react';
import { apiRequest } from '../../../services/api';

const Step5Complete = () => {
  const navigate = useNavigate();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    initializeCompletion();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const initializeCompletion = async () => {
    await Promise.allSettled([
      apiRequest('/api/v1/guides/signup/progress', {
        method: 'PATCH',
        body: JSON.stringify({ signupStage: 5 }),
      }),
      apiRequest('/api/v1/guides/signup/recovery-job', { method: 'DELETE' }),
    ]);
    setInitialized(true);
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-12 text-center">
      <div className="flex justify-center mb-6">
        <CheckCircle className="w-16 h-16 text-emerald-600" />
      </div>

      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        Your application is under review
      </h1>

      <p className="text-gray-600 mb-10">
        Thank you for applying to be an OutdoorGuides guide. Our team will review your
        application and get back to you shortly.
      </p>

      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 mb-10 text-left space-y-5">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">What happens next</h2>

        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-9 h-9 bg-emerald-100 rounded-full flex items-center justify-center">
            <Clock className="w-5 h-5 text-emerald-600" />
          </div>
          <div>
            <p className="font-medium text-gray-900">Application review (3-5 business days)</p>
            <p className="text-sm text-gray-600 mt-0.5">
              Our team reviews your credentials, experience, and service details to ensure a
              great experience for customers.
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-9 h-9 bg-emerald-100 rounded-full flex items-center justify-center">
            <Bell className="w-5 h-5 text-emerald-600" />
          </div>
          <div>
            <p className="font-medium text-gray-900">Approval notification</p>
            <p className="text-sm text-gray-600 mt-0.5">
              You&apos;ll receive an email when your application is approved (or if we need more
              information). Check your inbox for updates.
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-9 h-9 bg-emerald-100 rounded-full flex items-center justify-center">
            <Calendar className="w-5 h-5 text-emerald-600" />
          </div>
          <div>
            <p className="font-medium text-gray-900">Access to bookings post-approval</p>
            <p className="text-sm text-gray-600 mt-0.5">
              Once approved, your guide profile goes live and customers can book your services.
              You&apos;ll manage your calendar and bookings from your dashboard.
            </p>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => navigate('/guide/dashboard')}
        data-testid="dashboard-cta"
        className="px-8 py-3 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-colors shadow-sm"
      >
        Explore your guide dashboard
      </button>

      {initialized && <span data-testid="initialized" className="sr-only">ready</span>}
    </div>
  );
};

export default Step5Complete;
